package com.rajen.angrejidictionary.data.repository

import com.rajen.angrejidictionary.data.remote.WordApi
import com.rajen.angrejidictionary.data.remote.dto.ItemDto
import com.rajen.angrejidictionary.domain.model.*

class WordRepository {

    suspend fun getTodayWord(): Word {
        val response = WordApi.getTodayWord()
        val d = response.data ?: throw Exception(response.error?.message ?: "No word data received")
        return d.toWord()
    }

    suspend fun getWordByTerm(term: String): Word {
        val response = WordApi.getWordByTerm(term)
        val d = response.data ?: throw WordNotFoundException(response.error?.message ?: "Word not found")
        return d.toWord()
    }

    private fun ItemDto.toWord(): Word = Word(
        englishWord = word.englishWord,
        partOfSpeech = word.partOfSpeech,
        pronunciationGujarati = word.pronunciationGujarati,
        meanings = word.meaningGujarati,
        wordForms = wordForms.map { f ->
            WordForm(
                word = f.wordForm,
                partOfSpeech = f.partOfSpeech,
                pronunciationGujarati = f.pronunciationGujarati,
                meanings = f.meanings,
                exampleSentence = f.example?.sentence ?: "",
                examplePronunciationGujarati = f.example?.pronunciationGujarati ?: "",
                exampleMeaningGujarati = f.example?.meaningGujarati ?: ""
            )
        },
        similarWords = similarWords.map {
            RelatedWord(it.word, it.partOfSpeech, it.pronunciationGujarati, it.meanings)
        },
        oppositeWords = oppositeWords.map {
            RelatedWord(it.word, it.partOfSpeech, it.pronunciationGujarati, it.meanings)
        },
        usage = usage?.let {
            WordUsage(it.whenGujarati, it.whereGujarati, it.whyGujarati)
        },
        phrasals = phrasalUsage?.phrasals?.map { p ->
            PhrasalVerb(
                form = p.form,
                pronunciationGujarati = p.pronunciationGujarati,
                meanings = p.meanings,
                examples = p.examples.map { e ->
                    PhrasalExample(e.sentence, e.pronunciationGujarati, e.meaningGujarati)
                }
            )
        } ?: emptyList(),
        tenses = tenseExplanation?.tenses?.map { Tense(it.type, it.word) } ?: emptyList(),
        tenseRule = tenseExplanation?.rule ?: "",
        viewCount = viewCount
    )
}